var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColonired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25745 9.33311C8.25745 10.3656 7.80828 11.2989 7.09078 11.9348C6.47245 12.4948 5.65578 12.8331 4.75745 12.8331C2.82661 12.8331 1.25745 11.2639 1.25745 9.33311C1.25745 8.23776 1.76618 7.25821 2.55727 6.61736C2.79303 6.42637 3.12953 6.54702 3.27829 6.81147C3.84807 7.82442 4.80793 8.57817 5.93578 8.88394C6.30328 8.98895 6.68828 9.04145 7.09078 9.04145C7.33249 9.04145 7.56553 9.02195 7.79255 8.9856C8.02578 8.94826 8.25745 9.09691 8.25745 9.33311Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5908 4.66699C10.5908 5.12199 10.5033 5.55949 10.3458 5.95616C9.94332 6.97116 9.07999 7.75283 8.01249 8.04449C7.72082 8.12616 7.41165 8.16699 7.09082 8.16699C6.76999 8.16699 6.46082 8.12616 6.16915 8.04449C5.10165 7.75283 4.23832 6.97116 3.83582 5.95616C3.67832 5.55949 3.59082 5.12199 3.59082 4.66699C3.59082 2.73616 5.15999 1.16699 7.09082 1.16699C9.02165 1.16699 10.5908 2.73616 10.5908 4.66699Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9241 9.33311C12.9241 11.2639 11.3549 12.8331 9.42411 12.8331C9.09103 12.8331 8.76765 12.7865 8.46181 12.699C8.13404 12.6052 8.07328 12.1964 8.27718 11.9231C8.82938 11.1831 9.13245 10.2768 9.13245 9.33311C9.13245 9.13478 9.11495 8.93645 9.08578 8.74978C9.06842 8.64218 9.12333 8.5364 9.21869 8.48361C9.92178 8.09439 10.5075 7.5166 10.9034 6.81228C11.0522 6.54757 11.3889 6.42662 11.6248 6.61781C12.4156 7.25866 12.9241 8.23801 12.9241 9.33311Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColonired);
export default __webpack_public_path__ + "static/media/colonired.9565d9ac05816d2099ea49c18ceeb69e.svg";
export { ForwardRef as ReactComponent };